const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  generateUrl ({ state, commit, rootState }, params) {
    return rootState.axios.get('/push/v1frontend/linepush-auth/generate-url', { params })
  },
  revoke ({ state, commit, rootState }, params) {
    return rootState.axios.get('/push/v1frontend/linepush-auth/revoke', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
